import { Entity, Column, PrimaryGeneratedColumn, ManyToOne, JoinColumn, RelationId } from 'typeorm';
import { Categorie } from './categorie.entity';
import { Etiquette } from './etiquette.entity';

@Entity('etiquette_categorie')
export class EtiquetteCategorie {
    @PrimaryGeneratedColumn()
    id: number;

    @ManyToOne(() => Etiquette, { eager: true })
    @JoinColumn({ name: 'fk_id_etiquette' })
    etiquette: Etiquette;

    @ManyToOne(() => Categorie, { eager: true })
    @JoinColumn({ name: 'fk_id_categorie' })
    categorie: Categorie;

    @Column({ nullable: true })
    ordre_affichage: string;

    @RelationId((etiquetteCategorie: EtiquetteCategorie) => etiquetteCategorie.categorie)
    fk_id_categorie: number;

    @RelationId((etiquetteCategorie: EtiquetteCategorie) => etiquetteCategorie.etiquette)
    fk_id_etiquette: number;

    toJSON() {
        const { etiquette, ...rest } = this;
        return rest;
    }
}
